import { Typography } from "@mui/material";
import { Link } from "react-router-dom";

export function ColumnLinkBuilder(link: string, text: string, fontSize: number = 18) {
  return (<Link to={link} style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Typography fontSize={fontSize} noWrap sx={{ textOverflow: "ellipsis" }}>
            {text}
          </Typography>
        </Link>)
}